module.exports = __webpack_public_path__ + "static/media/08_tn.309265ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/08_tn.jpg
// module id = 644
// module chunks = 0